export const GET_LICENSE_SALES = "getLicenseSales";
export const GET_LICENSE_SALE = "getLicenseSale";
export const CHANGE_LICENSE_SALE_STATUS = "changeLicenseSaleStatus";